import { queryKeys } from '@/lib/query-keys';
import { siteClient } from '@/lib/api/ts-rest';
import { createLogger } from '@/lib/logger';
import type { UpdateSiteBody } from '@octave/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useUpdateSite = (organizationId: string) => {
  const queryClient = useQueryClient();
  const log = createLogger('useUpdateSite');
  return useMutation({
    mutationFn: async ({
      siteId,
      ...payload
    }: UpdateSiteBody & { siteId: string }) => {
      const res = await siteClient.updateSite({
        params: { siteId },
        body: payload,
      });
      if (res.status !== 200) throw new Error('Failed to update site');
      return res.body;
    },
    onSuccess: () => {
      toast.success('Centre de facturation mis à jour');
    },
    onError: (error) => {
      toast.error('La mise à jour a échoué');
      log.error('Failed to update site', { error });
    },
    onSettled: () => {
      // Invalidate both the sites query and the current organization query
      queryClient.invalidateQueries({
        queryKey: queryKeys.organizations.sites(organizationId),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.organizations.current(),
      });
    },
  });
};
